import React from 'react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { observer } from 'mobx-react';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import LinearProgress from '@mui/material/LinearProgress';
import { TierColors } from '@gamiphy/bl/level';

const ProgressBar: React.FC = observer(() => {
  const tierColor = LevelStore.currentTier?.color ?? TierColors.bronze;
  const progress = React.useMemo(
    () => ((LevelStore.accumulated ?? 0) / (LevelStore.nextTier?.neededAmount ?? 1)) * 100.0,
    [UserStore.user?.points.exp, LevelStore.nextTier?.neededAmount],
  );

  if (!UserStore.user) return null;

  return (
    <LinearProgress
      value={progress >= 100 ? 100 : progress}
      variant="determinate"
      sx={{
        borderRadius: 7,
        backgroundColor: '#dedede',
        height: '0.8rem',
        border: (theme) => `0.5px solid ${theme.palette.text.secondary}`,
        '& .MuiLinearProgress-bar1Determinate': {
          backgroundColor: tierColor,
        },
        color: tierColor,
      }}
    />
  );
});

export default ProgressBar;
